<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Iucosoft.
            </div>
        </div>
    </div>
</footer>
